import { Component, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subject, takeUntil } from 'rxjs';
import { NetworkService } from '../../services/network.service';
import { ClockSyncService } from '../../services/clock-sync.service';

export type ConnectivityIssue = 'offline' | 'clock-skew' | null;

@Component({
    selector: 'app-connectivity-overlay',
    templateUrl: './connectivity-overlay.component.html',
    styleUrl: './connectivity-overlay.component.scss'
})
export class ConnectivityOverlayComponent implements OnInit, OnDestroy {

    issue: ConnectivityIssue = null;

    private destroy$ = new Subject<void>();

    constructor(
        private network: NetworkService,
        private clockSync: ClockSyncService
    ) {}

    ngOnInit(): void {
        combineLatest([
            this.network.getNetworkStatus(),
            this.clockSync.isClockSynced()
        ]).pipe(
            takeUntil(this.destroy$)
        ).subscribe(([online, clockSynced]) => {
            const prevIssue = this.issue;

            if (!online) {
                this.issue = 'offline';
            } else if (!clockSynced) {
                this.issue = 'clock-skew';
            } else {
                this.issue = null;
            }

            // Issue resolved → reload so components re-fetch their data
            if (prevIssue && !this.issue) {
                window.location.reload();
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    retry(): void {
        this.clockSync.recheck();
    }
}
